import React from 'react';

export interface Props {
  text: string,
}

export default function StoryletDescription({ text }: Props) {
  return (
    <div className="storylet__description-container" dangerouslySetInnerHTML={{ __html: text }} />
  );
}
